import React from 'react';
import parse from 'html-react-parser';
function DiscountHeader({ data }: { data: string }) {
  return (
    <div className="d-flex bg-dark w-100 justify-content-center text-center align-items-center py-1 py-lg-2">
      <p className="m-0 text-white fs-small">{data && parse(data)}</p>
    </div>
  );
}

export default DiscountHeader;
